import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../lib/smooth";

const NAV = [
    { label: "Profile", href: "#profile" },
    { label: "Epoxy Boxes", href: "#epoxy-box" },
    { label: "Process", href: "#process" },
    { label: "Machinery", href: "#machinery" },
    { label: "Products", href: "#products" },
    { label: "Enquiry", href: "#enquiry" },
];

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-[#060607] border-t border-zinc-900">
            <div className="safety-stripes h-1.5" />
            <div className="shell py-16 md:py-20">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <Logo />
                        <p className="mt-6 font-display uppercase text-xl md:text-2xl font-medium tracking-wide text-zinc-300 leading-snug max-w-sm">
                            “Engineered FRP Solutions for Electrical &amp; Industrial
                            Applications”
                        </p>
                        <p className="mt-4 text-sm text-zinc-500 leading-relaxed max-w-sm">
                            FRP • GFRP • Epoxy Fiberglass Components • Electrical
                            Insulation Products — manufactured to approved customer
                            drawings in SIDA, Jaunpur, Uttar Pradesh.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-safety mb-5">
                            Navigate
                        </div>
                        <nav className="flex flex-col gap-3">
                            {NAV.map((n) => (
                                <a
                                    key={n.href}
                                    href={n.href}
                                    data-testid={`footer-link-${n.href.slice(1)}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        scrollToId(n.href);
                                    }}
                                    className="font-display uppercase tracking-wide text-zinc-400 hover:text-safety transition-colors text-sm w-fit flex items-center gap-2"
                                >
                                    {n.label} <ArrowUpRight size={13} />
                                </a>
                            ))}
                        </nav>
                    </div>

                    <div className="md:col-span-4">
                        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-safety mb-5">
                            NAAGARJUN POWER FIBER
                        </div>
                        <p className="text-sm text-zinc-400 leading-relaxed">
                            Plot No. G-27, Road No. 10,<br />
                            SIDA, Satharia, Jaunpur,<br />
                            Uttar Pradesh – 222202, India
                        </p>
                        <div className="mt-5 space-y-2.5">
                            <a
                                href="tel:+919648881601"
                                data-testid="footer-phone-1"
                                className="flex items-center gap-3 text-sm text-zinc-300 hover:text-safety transition-colors w-fit"
                            >
                                <Phone size={14} className="text-safety" /> +91 9648881601
                            </a>
                            <a
                                href="tel:+919794946308"
                                data-testid="footer-phone-2"
                                className="flex items-center gap-3 text-sm text-zinc-300 hover:text-safety transition-colors w-fit"
                            >
                                <Phone size={14} className="text-safety" /> +91 9794946308
                            </a>
                            <a
                                href="mailto:naagarjunpowerfiber@gmail.com"
                                data-testid="footer-email"
                                className="flex items-center gap-3 text-sm text-zinc-300 hover:text-safety transition-colors w-fit break-all"
                            >
                                <Mail size={14} className="text-safety" /> naagarjunpowerfiber@gmail.com
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-zinc-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <span className="font-mono text-[11px] text-zinc-600 tracking-wide">
                        © {year} NAAGARJUN POWER FIBER — FRP Sheets & Components Manufacturer
                    </span>
                    <span className="font-mono text-[11px] text-zinc-600 tracking-wide">
                        naagarjunpowerfiber.in
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;